import { apiClient } from "../config";
async function getBrandDetailByUrl(url: any) {
    const res = await apiClient.get(`/admin/brand-detail/${url}`);
    return res.data;
}
export default getBrandDetailByUrl;